module.exports = __webpack_public_path__ + "img/emoji-saddest-off.b3646ac3.svg";